module.exports = __webpack_public_path__ + "img/c79204a.png";